import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import { Container, Stack, Grid } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import EirAddSimhandsetModal from '../../../components/eir-add-sim-handset/EirAddSimhandsetModal';
import { useToggle } from '../../../hooks/useToggle';
import EirOrderSummary from '../../../components/eir-order-summary/EirOrderSummary';
import useLocalStorage, {
  clearLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '../../../hooks/useLocalStorage';
import {
  getCookie,
  getTokenFromCookies,
  removeCookie,
  deleteCookie,
  setCookie,
} from '../../../hooks/useCookie';
import RootContext from '../../../../util/root.context';
import getCarts from '../../../integration/cart.api';
import { removeTariff } from '../../../components/eir-broadband/Broadband.util';
import {
  displayCart,
  getCartDetails,
  getCartInfo,
  getTacticalOfferDetails,
} from '../../../components/eir-cart/cart.util';
import RemoveConfirmationModal from '../../../components/eir-cart/RemoveConfirmationModal';
import ClearCartConfirmationModal from '../../../components/eir-cart/ClearCartConfirmationModal';
import getStrapiData from '../../../integration/strapi';
import { removeFromCartAnalytics, viewCartAnalytics } from '../../../../util/gtm';
import { removeAddOns, removeEquipmentAddOn } from '../../../integration/addons.api';
import ErrorModal from '../../../components/eir-error-modal/ErrorModal';
import NavBar from '../../../components/eir-nav-bar/NavBar';
import EirMetaTag from '../../../components/eir-meta-tag/EirMetaTag';
import FaqContainer from '../../../components/eir-mobile-broadband/FaqContainer';
import styles from '../../../components/eir-order-summary/style';
import LoginMain403 from '../../../components/eir-403-login/LoginMain403';
import SessionExpireModal from '../../../components/eir-session-expire-modal/sessionExpireModal';
import ApiFailureModal from '../../../components/eir-error-modal/ApiFailureModal';
import { SERVICE_GROUPS } from '../../../components/shared/Constants';
import EirHeader from '../../../components/eir-header/EirHeader';
import {
  getCodeForSimType,
  handleSimTypeUpdate,
} from '../../../components/eir-simtype-selector/simtypeSelector.util';

export async function getServerSideProps() {
  let cmsHeaderData = {};
  const cmsData = await getStrapiData('order-summary');
  cmsHeaderData = await getStrapiData('header');
  return {
    props: {
      cmsData: cmsData?.data,
      cmsHeaderData,
    },
  };
}

const Summary = ({ cmsData, cmsHeaderData }) => {
  const theme = useTheme();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const [cartData, setCartData] = useState({});
  const [cartInfo, setCartInfo] = useState({});
  const [tacticalOffers, setTacticalOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const openAPIFailureModal = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const errorModalMaxOccurence = 1;
  const errorModal = useToggle(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const openAccountCheck = useToggle(false);
  const openConfirmationModal = useToggle(false);
  const openClearCartConfirmationModal = useToggle(false);
  const localStore = useLocalStorage();
  const graphql = useApolloClient();
  const [cartItemName, setCartItemName] = useState('');
  const [cartItemOfferId, setCartItemOfferId] = useState('');
  const [cartItemAddOnId, setCartItemAddOnId] = useState('');
  const [cartItemEquipmentId, setCartItemEquipmentId] = useState('');
  const [offerType, setOfferType] = useState('');
  const { state: rootState, dispatch } = useContext(RootContext);
  const [emptyCart, setEmptyCart] = useState(false);
  const [additionalAllowedOffers, setAdditionalAllowedOffers] = useState(0);
  const [isCurrentServiceComplete, setIsCurrentServiceComplete] = useState(false);
  // const [isPortingComplete, setIsPortingComplete] = useState(false);
  const [isMobileInCart, setIsMobileInCart] = useState(false);
  const [hasMissingStep, setHasMissingStep] = useState(true);
  const [handsetInCart, setHandsetInCart] = useState(false);
  const [systemAddedOffer, setSystemAddedOffer] = useState(false);
  const [incompleteCart, setIncompleteCart] = useState(false);
  const [pSIMCode, setPSIMCode] = useState();
  const [showSIMModal, setShowSIMModal] = useState(false);

  const getClickedItem = (itemName, itemId, addOnId, itemType, equipmentId) => {
    setCartItemOfferId(itemId);
    setCartItemName(itemName);
    setCartItemAddOnId(addOnId);
    setOfferType(itemType);
    setCartItemEquipmentId(equipmentId);
  };
  const getSIMCardType = simCardTypes => {
    let equipmentType;
    if (simCardTypes) {
      if (simCardTypes.includes('NANO') && simCardTypes.includes('ESIM')) {
        equipmentType = 'HYBRID';
      } else if (simCardTypes.includes('NANO')) {
        equipmentType = 'PSIM';
      } else if (simCardTypes.includes('ESIM')) {
        equipmentType = 'ESIM';
      }
    }
    return equipmentType;
  };
  const checkIfSIMInCart = cartDetails => {
    setIsMobileInCart(cartDetails.haveMobileOffers);
  };
  const handleOk = () => {
    openAPIFailureModal.disable();
  };

  let isPageLoading = false;
  const onPageLoad = async () => {
    if (isPageLoading) return; // Prevent re-entry
    setLoading(true);
    isPageLoading = true;
    console.log('page loading');
    dispatch({ type: 'ENABLE_LOGIN_BUTTON', payload: false });

    setIncompleteCart(false);
    try {
      displayCart({
        dispatch,
        showCart: false,
      });
      if (localStore.hasValue('prospectuuid')) {
        dispatch({ type: 'SHOW_CART', payload: false });
        if (localStore.hasValue('APPOINTMENT_TYPE')) setIsCurrentServiceComplete(true);
        // if (getLocalStorage('PORTIN') === 'true') setIsPortingComplete(true);
        const { getCart: cart } = await getCarts({
          graphql,
          variables: { reference: localStore.getLocalStorage('PROSPECTUUID') },
        });
        const mobileOfferCatalogCode = cart?.offers.filter(
          offer => offer.baseOffer.serviceGroup === 'MOBILE'
        )[0]?.baseOffer?.catalogCode;
        setPSIMCode(await getCodeForSimType(graphql, 'ALL_IN_1', mobileOfferCatalogCode));
        const mobileOffersWithoutSimTypes = cart?.offers?.filter(
          offer =>
            offer.baseOffer?.serviceGroup === SERVICE_GROUPS.MOBILE &&
            !offer.inclusiveEquipments.length
        );

        let SIMUpdateSuccess;
        if (mobileOffersWithoutSimTypes.length) {
          await Promise.all(
            mobileOffersWithoutSimTypes.map(async offer => {
              SIMUpdateSuccess = await handleSimTypeUpdate({
                SIMType:
                  getSIMCardType(offer?.equipments[0]?.simCardTypes) === 'ESIM'
                    ? 'ESIM'
                    : 'ALL_IN_1',
                offerId: offer?.id,
                offerCode:
                  getCookie('cart_Type') === 'CHANGE_OFFER' ? offer?.baseOffer?.catalogCode : '',
                graphql,
                localStore,
                url: '/shop/summary',
              });
            })
          );

          if (SIMUpdateSuccess) {
            isPageLoading = false;
            await onPageLoad(); // Called after all updates are done
          } else {
            isPageLoading = false;
            setErrorModalOccurence(errorModalOccurence + 1);
            errorModal.enable();
          }
        } else {
          console.log('Normal cart', cart);
          const cartDetails = await getCartInfo(cart);
          checkIfSIMInCart(cartDetails);
          viewCartAnalytics('mainCart', cart);
          dispatch({ type: 'SET_CART', payload: cart });
          if (cart.offers.length > 0) {
            setCartData(getCartDetails(cart));
            setCartInfo(cartDetails);
            setAdditionalAllowedOffers(cartDetails.additionalAllowedOffers);
            if (cartDetails?.haveBroadbandOffers && tacticalOffers.length === 0) {
              setTacticalOffers(await getTacticalOfferDetails(graphql));
            }
            setEmptyCart(false);

            if (
              cartDetails?.noOfMobileOffers < 2 &&
              cartDetails?.isPortInDone &&
              !rootState?.insuranceTermsChecked?.status
            ) {
              localStore.setLocalStorage('ADDITIONAL_OFFERS_ALLOWED', 'true');
              openAccountCheck.enable();
            } else {
              localStore.setLocalStorage('ADDITIONAL_OFFERS_ALLOWED', 'false');
            }

            // if (!localStore.hasValue('ENABLE_MULTI_OFFERS') && cartDetails.haveMobileOffers)
            //   openAccountCheck.enable();

            setOpenError(false);
            openAPIFailureModal.disable();
            setErrorModalOccurence(0);
            errorModal.disable();
            if (getLocalStorage('STANDALONE_HANDSET')) {
              if (
                cart?.offers.filter(
                  element => element.id === parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10)
                ).length > 0 &&
                cart.offers.length === 1
              ) {
                setEmptyCart(true);
              }

              if (
                cart?.offers.filter(
                  element => element.id === parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10)
                ).length > 0 &&
                cart.offers.filter(element => element.equipments).length > 0
              ) {
                setSystemAddedOffer(true);
              }
            }
            if (cartDetails.hasUpfrontCostItem) {
              setHandsetInCart(true);
            }
          } else {
            setEmptyCart(true);
          }
        }
      }
    } catch (error) {
      isPageLoading = false;
      console.error(error);
      setOnLoadError(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorModal.enable();
      if (!getCookie('token-missing')) errorModal.enable();
      // TODO Set notification from here when api fails.
    }
    setLoading(false);
    isPageLoading = false; // Reset flag after completion
  };

  /* Removing Items from the cart onClick of editCart */
  const removeItems = async () => {
    if (rootState.cart?.offers.length > 0) {
      const offerId = parseInt(cartItemOfferId, 10);
      const addOnId = parseInt(cartItemAddOnId, 10);
      const equipmentId = parseInt(cartItemEquipmentId, 10);
      const prospect = localStore.getLocalStorage('PROSPECTUUID');
      if (addOnId && !equipmentId) {
        const variables = {
          reference: prospect,
          offerId,
          addOnId,
          cartType: getCookie('cart_type') ? getCookie('cart_type') : 'NEW_ACQUISITION',
          token: getTokenFromCookies() || '',
        };
        const data = await removeAddOns({ graphql, variables });
        if (data != null && !data.error) {
          removeFromCartAnalytics(data);
          setIncompleteCart(false);
          dispatch({ type: 'SET_CART', payload: data });
          openConfirmationModal.disable();
          onPageLoad();
        } else {
          setOnLoadError(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          setCookie('ION', 'API_FAILED', 'getCarts');
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
          console.log(
            data.error.message
              ? `Notification: ${data.error.message}`
              : 'Something went wrong. Try again!'
          );
        }
      } else if (addOnId && equipmentId) {
        const variables = {
          reference: prospect,
          offerId,
          addOnId,
          equipmentId,
        };
        const data = await removeEquipmentAddOn({ graphql, variables });
        if (data != null && !data.error) {
          removeFromCartAnalytics(data);
          dispatch({ type: 'SET_CART', payload: data });
          dispatch({ type: 'SET_INSURANCE_TERMS_CHECKED', payload: { status: false } });
          setIncompleteCart(false);
          openConfirmationModal.disable();
          onPageLoad();
        } else {
          setOnLoadError(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          setCookie('ION', 'API_FAILED', 'removeEquipmentAddOn');
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
          console.log(
            data.error.message
              ? `Notification: ${data.error.message}`
              : 'Something went wrong. Try again!'
          );
        }
      } else {
        const offerData = await removeTariff(graphql, offerId);
        if (offerType === 'DUALPLAY') {
          removeLocalStorage('APPOINTMENT_TYPE');
        }
        if (
          rootState.cart?.offers
            .filter(offer => offer.baseOffer.simOnly === false)
            .filter(offer => offer.equipments.length === 0)
            .filter(offer => offer.id === offerId).length === 1
        ) {
          localStore.removeLocalStorage('BILLPAY_JOURNEY');
        }
        if (offerData != null && !offerData.error) {
          setIncompleteCart(false);
          removeFromCartAnalytics(offerData);
          dispatch({ type: 'SET_CART', payload: offerData });
          openConfirmationModal.disable();
          onPageLoad();
        } else {
          setIncompleteCart(false);
          setOnLoadError(true);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          setCookie('ION', 'API_FAILED', 'removeTariff');
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorModal.enable();
          if (!getCookie('token-missing')) errorModal.enable();
          console.log(
            offerData.error.message
              ? `Notification: ${offerData.error.message}`
              : 'Something went wrong. Try again!'
          );
        }
      }
    }
    localStorage.removeItem('prospectUuid');
    removeCookie('prepay_prospectUuid');

    removeCookie('orderId');
    deleteCookie('eir_current_order');
  };

  /* Clearing cart */
  const clearCartData = () => {
    clearLocalStorage();
    setEmptyCart(true);
    dispatch({ type: 'SET_CART', payload: null });
    removeCookie('COMP_MAP');
    removeCookie('cart_Type');
    removeCookie('reference');
    openClearCartConfirmationModal.disable();
  };

  useEffect(() => {
    if (!isPageLoading) onPageLoad();
  }, [rootState.insuranceTermsChecked.status]);
  useEffect(() => {
    if (getLocalStorage('ADDITIONAL_OFFERS_NEEDED') === 'false') setShowSIMModal(true);
  }, []);

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  return (
    <Stack
      sx={{
        backgroundSize: '100%',
        backgroundColor: theme.palette.primary.backgroundColor,
        minHeight: '100dvh',
      }}
    >
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        {handsetInCart && !emptyCart && (
          <NavBar
            headerText='2-3 day delivery after order completion'
            headerIcon={
              <LocalShippingIcon
                sx={{ color: theme.palette.secondary.contrastText, mr: 1, fontSize: '1rem' }}
              />
            }
          />
        )}
        <EirMetaTag seo={cmsData?.attributes?.Seo_Summary} />

        {!hasMissingStep && additionalAllowedOffers > 0 && isMobileInCart && !showSIMModal && (
          <EirAddSimhandsetModal
            openAccountCheck={openAccountCheck}
            localStore={localStore}
            cmsData={cmsData}
          />
        )}
        <Container maxWidth='lg' sx={{ p: 0, minHeight: '70vh' }}>
          <EirOrderSummary
            cmsData={cmsData}
            loading={loading}
            setloading={setLoading}
            cartData={cartData}
            tacticalOffers={tacticalOffers}
            cartInfo={cartInfo}
            openConfirmationModal={openConfirmationModal}
            getClickedItem={getClickedItem}
            emptyCart={emptyCart}
            isCurrentServiceComplete={isCurrentServiceComplete}
            // isPortingComplete={isPortingComplete}
            setEmptyCart={setEmptyCart}
            openClearCartConfirmationModal={openClearCartConfirmationModal}
            clearCartData={clearCartData}
            systemAddedOffer={systemAddedOffer}
            setHasMissingStep={state => {
              setHasMissingStep(state);
            }}
            setIncompleteCart={setIncompleteCart}
            incompleteCart={incompleteCart}
            pSIMCode={pSIMCode}
            refreshSummary={onPageLoad}
          />
        </Container>
        {cmsData?.attributes?.Summary_FAQ_List.length > 0 && (
          <Grid
            xs={12}
            sx={{
              background: theme.palette.primary.backgroundColor3,
              ...styles(theme).faqContainerSuperMain,
            }}
          >
            <FaqContainer
              InsuranceHeading={cmsData?.attributes?.Summary_FAQ_Title}
              InsuranceList={cmsData?.attributes?.Summary_FAQ_List}
            />
          </Grid>
        )}
        {openConfirmationModal.value && (
          <RemoveConfirmationModal
            openConfirmationModal={openConfirmationModal}
            cartItemOfferId={cartItemOfferId}
            cartItemAddOnId={cartItemAddOnId}
            cartItemName={cartItemName}
            removeItems={removeItems}
            cartItemEquipmentId={cartItemEquipmentId}
          />
        )}
        {openClearCartConfirmationModal.value && (
          <ClearCartConfirmationModal
            openClearCartConfirmationModal={openClearCartConfirmationModal}
            clearCartData={clearCartData}
          />
        )}
        {openError && errorModalOccurence > errorModalMaxOccurence && (
          <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
        )}
        {showModal.value && <LoginMain403 />}
        {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
          <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
        )}
        {errorModal.value && !showModal.value && !showSessionExpiredModal.value && (
          <ErrorModal
            errorBBModal={errorModal}
            occurences={errorModalMaxOccurence}
            currentOccurence={errorModalOccurence}
            ctaMethod={onLoadError ? onPageLoad : () => {}}
          />
        )}
      </main>
    </Stack>
  );
};

export default Summary;
